import type { QuizResult } from '@mentimeter/quiz-types';

export const generateResult = (
  rawResults: QuizResult[],
  choices: {
    legacyChoiceId: number | null;
    title: string;
    markedCorrect: boolean;
  }[],
) => {
  return choices.map((choice, index) => {
    const responses = rawResults.find(
      (response) => response.choice_id === choice.legacyChoiceId,
    )?.responses;
    return {
      id: choice.legacyChoiceId ?? index + 1,
      label: choice.title,
      score: responses || 0,
      correct_answer: choice.markedCorrect,
    };
  });
};
